import { render, staticRenderFns } from "./table-form.vue?vue&type=template&id=657debb8&scoped=true&"
import script from "./table-form.vue?vue&type=script&lang=js&"
export * from "./table-form.vue?vue&type=script&lang=js&"
import style0 from "./table-form.vue?vue&type=style&index=0&id=657debb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657debb8",
  null
  
)

export default component.exports